import { motion } from 'framer-motion';
import styled, { css, keyframes } from 'styled-components';

import HeaderImage from '@pkg/assets/images/onboarding/welcome-header.jpg';

export const ONBOARDING_ACTIVITY_CLASS = 'onboarding--activity-panel';
export const ONBOARDING_SETTINGS_CLASS = 'onboarding--settings';
export const ONBOARDING_PROFILE_EDIT_CLASS = 'onboarding--profile-edit';
export const ONBOARDING_LID_EDIT_CLASS = 'onboarding--liquid-id-edit';
export const ONBOARDING_PROFILE_CREATE_CLASS = 'onboarding--profile-create';
export const ONBOARDING_NDV_OWNER_CLASS = 'onboarding--owner-panel';
export const ONBOARDING_COLLECTION_FILTERS__CLASS = 'onboarding--collection-filters';
export const ONBOARDING_FANTASY_GENERATE_BUTTON_CLASS = 'onboarding--fantasy-generate-button';

// Welcome Tutorial
export const FullScreenWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 1000;
`;

export const WelcomeModalWrapper = styled(motion.div)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: #2a2637;
    overflow: hidden;

    height: 100%;
    width: 100%;
    max-width: unset;
    padding: 90px 25px 50px 25px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        max-width: 540px;
        height: fit-content;
        padding: 0 0 40px 0;
        border-radius: 30px;
    }
`;

export const WelcomeTitle = styled(motion.div)`
    margin-bottom: 15px;
    text-align: center;
`;

export const WelcomeContent = styled(motion.div)`
    margin-bottom: 25px;
    text-align: center;
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 0 38px;
    }
`;

export const WelcomeButton = styled(motion.div)`
    width: fit-content;
`;

export const Background = styled(motion.div)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.75;
`;

export const ImageHeaderContainer = styled.div`
    overflow: hidden;
    height: 200px;
    width: calc(100% + 50px);
    margin-bottom: 45px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 290px;
        width: 100%;
    }
`;

export const ImageHeader = styled(motion.div)`
    background-image: url(${HeaderImage});
    background-size: cover;
    background-position: center center;
    width: 100%;
    height: 100%;
`;

// Onboarding Tutorial (Slider)

const borderAnimation = keyframes`
	0% { background-position: 0 0; }
	50% { background-position: 20px 20px; }
	100% { background-position: 0 0; }
`;

export const OnboardingWrapper = styled(motion.div)<{ $left?: boolean; $size?: string }>`
    position: fixed;
    /* temp */
    top: 400px;
    left: 400px;
    /* end temp */
    z-index: 1002;
    /* Make multiple size */
    width: 355px;
    height: fit-content;
    padding: 25px 30px;
    transition: height 200ms cubic-bezier(0.33, 1, 0.68, 1);

    ${({ $size }) => {
        switch ($size) {
            case 'small':
                return css`
                    width: 325px;
                `;
            case 'large':
                return css`
                    width: 455px;
                `;
            default:
                return css`
                    width: 355px;
                `;
        }
    }}

    &::before {
        content: '';
        position: absolute;
        z-index: -1;
        top: -1px;
        left: -1px;
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        border-radius: 12px;
        opacity: 0.7;
        background-repeat: no-repeat;
        background: linear-gradient(
            -40deg,
            rgba(255, 255, 255, 1) 0%,
            rgba(0, 0, 0, 0) 33%,
            rgba(255, 255, 255, 1) 66%,
            rgba(0, 0, 0, 0) 100%
        );

        animation-name: ${borderAnimation};
        animation-duration: 3s;
        animation-iteration-count: infinite;
    }

    &::after {
        content: '';
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 12px;
        background-color: #090719;
    }
`;

export const OnboardingSlide = styled(motion.div)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: fit-content;
`;

export const OnboardingImage = styled.img`
    max-width: 100%;
    height: auto;
    max-height: 120px;
    object-fit: contain;
    object-position: left;
`;

export const OnboardingTitle = styled.div`
    margin-top: 20px;
    margin-bottom: 10px;
`;

export const OnboardingContent = styled.div`
    margin-bottom: 25px;
`;

export const OnboardingSliderDots = styled.div`
    position: absolute;
    right: 30px;
    bottom: 45px;
    display: flex;
`;

export const OnboardingSliderDot = styled.div<{ active?: boolean }>`
    margin-left: 4px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #fff;
    opacity: 0.4;
    cursor: pointer;
    transition: opacity 400ms cubic-bezier(0.33, 1, 0.68, 1);

    &:hover {
        opacity: 0.8;
    }

    ${({ active }) =>
        active &&
        css`
            opacity: 1;
            &:hover {
                opacity: 1;
            }
        `}
`;

export const OnboardingButtonContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const OnboardingSkipButton = styled.button`
    outline: 0;
    border: 0;
    padding: 0;
    background: transparent;
    margin: 0;
    margin-left: 20px;
    height: fit-content;
    padding-bottom: 1px;
    overflow: hidden;
    font-size: 18px;
    color: #fff;
    cursor: pointer;
    position: relative;
    &:after,
    &:before {
        content: '';
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 1px;
        background-color: #fff;
        left: 0;
        transition: transform 400ms cubic-bezier(0.33, 1, 0.68, 1);
    }
    &:before {
        transform: translateX(-100%);
    }
    &:hover {
        &:after {
            transform: translateX(100%);
        }
        &:before {
            transition: transform 200ms cubic-bezier(0.33, 1, 0.68, 1);
            transition-delay: 300ms;
            transform: translateX(0);
        }
    }
`;

// Cut Out Overlay

export const Overlay = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    /* pointer-events: none; */
`;

export const Mask = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    svg {
        width: 100%;
        height: 100%;
    }
`;
